import styled from 'styled-components';

export const StyledSVG = styled.svg`
  display: 'inline-block',
  width: '100%',
  height: '100%',
  strokeWidth: 0,
  stroke: 'white',
  fill: 'white'
`;
